import { post } from './ajax';
import { error } from './logger';

type UserActionData = {
  name: string;
  value?: number;
  actionTime?: number;
  createTime?: number;
  eventId?: string;
  metadata?: { [key: string]: string };
};

export const sendUserAction = (userId: string, actionData: UserActionData) => {
  try {
    post(
      `/gateway/api/v1/community/kudos/users/${userId}/actions`,
      {
        ...actionData,
        consumerKey: 'profile',
      },
      {
        credentials: 'include',
      },
    );
  } catch (e: Error | unknown) {
    console.log('catching!');
    error(
      'error-kms',
      'sendUserActionError',
      'Error sending user action',
      e as Error,
    );
  }
};
